var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 12.5H14.375V5.625H7.5V4.375H14.375C14.7065 4.375 15.0245 4.5067 15.2589 4.74112C15.4933 4.97554 15.625 5.29348 15.625 5.625V12.5Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 14.375V1.25H4.375V4.375H1.25V5.625H4.375V14.375C4.375 14.7065 4.5067 15.0245 4.74112 15.2589C4.97554 15.4933 5.29348 15.625 5.625 15.625H14.375V18.75H15.625V15.625H18.75V14.375H5.625Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/Crop.9572996cc8c2e43a26da1f889a34ef85.svg";
export { ForwardRef as ReactComponent };